import { Component, OnInit } from '@angular/core';

export interface PeriodicElement {
  store: string;
  pending: number;
  overdue: number;
  late: number;
  total: number;

}
const ELEMENT_DATA: PeriodicElement[] = [
  { store: '000822', pending: 2, overdue: 0, late: 0 ,'total':1},
  { store: '000823', pending: 3, overdue: 1, late: 1 ,'total':5},
  { store: '000824', pending: 4, overdue: 3, late: 2 ,'total':9},
  { store: '000825', pending: 3, overdue: 1, late: 1 ,'total':5}


];

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: false
})
export class TableComponent implements OnInit {
  constructor() {}
  displayedColumns: string[] = ['store', 'pending', 'overdue', 'late','total'];
  dataSource: PeriodicElement[] = ELEMENT_DATA;

  ngOnInit(): void {}
}
